module.exports = __webpack_public_path__ + "img/13.fa797ebe.png";